import { useCallback, useContext } from 'react';
import { DOWNLOAD_BANNER_STATUS } from 'models/Download';
import api from 'api';
import downloadService from 'services/downloadService';
import FileDownloadContext from 'providers/FileDownload/FileDownload.context';

export default function useStartDownloadingFile() {
  const { showDownloadBanner } = useContext(FileDownloadContext);

  return useCallback(
    async (nodeId: string) => {
      try {
        showDownloadBanner(DOWNLOAD_BANNER_STATUS.PREPARING);
        await api.dataRoom.nodes.startDownloadingFile(
          nodeId,
          downloadService.downloadUniqueId,
        );
      } catch {
        showDownloadBanner(DOWNLOAD_BANNER_STATUS.ERROR);
      }
    },
    [showDownloadBanner],
  );
}
